import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { Avatar, type AvatarProps } from "mds/components/Avatar";
import type { BaseSizeType } from "mds/global-types";

type InitialsAvatarSize = Extract<BaseSizeType, "s" | "m">;

const SIZE_CLASSES: Record<InitialsAvatarSize, string> = {
  s: "size-6 text-[8px]",
  m: "size-8 text-sm",
};

export interface InitialsAvatarProps extends Omit<AvatarProps, "children"> {
  initials: string;
  isSelected?: boolean;
  size?: InitialsAvatarSize;
}

export const InitialsAvatar: FC<InitialsAvatarProps> = ({
  className,
  initials,
  isSelected = false,
  size = "s",
  ...props
}) => (
  <Avatar
    {...props}
    className={twMerge(
      "shrink-0 bg-blue-tint-93 font-medium text-blue shadow-none",
      SIZE_CLASSES[size],
      isSelected && "bg-transparent text-white",
      className,
    )}
  >
    {initials.toLocaleUpperCase()}
  </Avatar>
);
